var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.colors && _vm.item.colors.length > 0
    ? _c(
        "div",
        {
          key: _vm.viewMode,
          staticClass: "wf-search-result description no-min-height",
          attrs: { id: _vm.productIndex + 1 + "-" + _vm.item.styleNumber }
        },
        [
          _vm.isCompare == true
            ? _c(
                "div",
                {
                  staticClass: "custom-control",
                  class: _vm.toggleButton ? "search-result-checkbox" : ""
                },
                [
                  _c("input", {
                    staticClass: "custom-control-input",
                    attrs: {
                      type: "checkbox",
                      disabled:
                        _vm.getCompareProducts.length > 11 &&
                        !_vm.getCompareProducts.some(function(el) {
                          return el.sellingStyleNumber === _vm.item.styleNumber
                        }),
                      id: "compareCheckbox-" + _vm.item.styleNumber
                    },
                    domProps: {
                      checked: _vm.getCompareProducts.some(function(el) {
                        return el.sellingStyleNumber === _vm.item.styleNumber
                      })
                    },
                    on: {
                      click: function($event) {
                        return _vm.compareNow(_vm.item)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "compareCheckbox-" + _vm.item.styleNumber }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$resourceString["product.Search.Label.Compare"]
                        )
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "wf-swiper",
                  rawName: "v-wf-swiper",
                  value: {
                    parameters: {
                      initialSlide: _vm.item.colors.findIndex(function(c) {
                        return c.colorNumber === _vm.currentColorNumber
                      }),
                      allowTouchMove: false
                    },
                    slideChangeEvent: _vm.onSlideChange
                  },
                  expression:
                    "{\n      parameters: {\n        initialSlide: item.colors.findIndex(\n          c => c.colorNumber === currentColorNumber\n        ),\n        allowTouchMove: false\n      },\n      slideChangeEvent: onSlideChange\n    }"
                }
              ],
              staticClass: "swiper-container swiper-wf-product-quick-view"
            },
            [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(_vm.item.colors, function(color) {
                  return _c(
                    "div",
                    { key: color.colorNumber, staticClass: "swiper-slide" },
                    [
                      _c(
                        "div",
                        { staticClass: "wf-product-quick-view-swatch-slide" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "px-0 w-100 cart-item-model-no",
                              attrs: {
                                href: _vm.$helpers.getProductDetailUrl(
                                  _vm.item.styleNameURL,
                                  _vm.item.styleNumber,
                                  color.colorNumber
                                )
                              },
                              on: {
                                click: function($event) {
                                  _vm.redirectToProductDetail($event)
                                  _vm.$gtm.productClickEvent(
                                    _vm.item,
                                    _vm.productIndex,
                                    _vm.selectedFilters,
                                    _vm.inStock,
                                    _vm.filterByFaceWeight
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "wf-product-quick-view-swatch-slide-image"
                                },
                                [
                                  _c("img", {
                                    staticClass: "image pdp-result-img",
                                    attrs: {
                                      alt: color.colorNumber,
                                      src:
                                        _vm.viewMode === "swatch"
                                          ? _vm.$helpers.getColorThumbnailImageUrl(
                                              _vm.item.styleNumber,
                                              color.colorNumber
                                            )
                                          : _vm.$helpers.getInteractiveRoomSceneImageUrl(
                                              _vm.item.styleNumber,
                                              color.colorNumber,
                                              _vm.item.roomsceneIds[
                                                _vm.rngRoom
                                              ],
                                              _vm.itemInstallMethodCode,
                                              500
                                            )
                                    },
                                    on: { error: _vm.handleImageError }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              color.pdqId == "1"
                                ? _c(
                                    "div",
                                    { staticClass: "wf-product-tile-pdq" },
                                    [
                                      _c("span", {
                                        staticClass:
                                          "png-icon png-icon-icons-symbols--ko-txtpdq"
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "active-color-header position-absolute d-flex flex-column"
                                },
                                [
                                  _c("div", { staticClass: "mt-1" }, [
                                    _c("b", [
                                      _vm._v(_vm._s(_vm.item.styleName))
                                    ]),
                                    _vm._v(" - " + _vm._s(_vm.item.styleNumber))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.item.inventoryType) +
                                        " - " +
                                        _vm._s(_vm.item.productTypeDesc)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.item.collectionName
                                    ? _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$resourceString[
                                              "site.search.collection.result.header"
                                            ]
                                          ) +
                                            ": " +
                                            _vm._s(_vm.item.collectionName)
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.item.colors.length === 1
                                          ? _vm.item.colors.length + " COLOR"
                                          : _vm.item.colors.length + " COLORS"
                                      ) +
                                        " - " +
                                        _vm._s(color.colorName)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.inStock && color.realTimeInventory
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-success wf-search-results-details"
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$resourceString[
                                                  "generic.product.instockavailable"
                                                ]
                                              ) +
                                              "\n                " +
                                              _vm._s(color.realTimeInventory) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "\n        wf-swiper-thumbnails wf-swiper-thumbnails-with-nav-buttons\n        d-none\n        on-hover-thumbnails\n        ml-3 mr-3\n      ",
                  class: "wf-product-thumbnails-size-" + _vm.tileSize
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wf-swiper-thumbnails-container" },
                    _vm._l(_vm.item.colors, function(color) {
                      return _c(
                        "div",
                        {
                          key: color.colorNumber,
                          staticClass: "wf-swiper-thumbnail"
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "cart-item-model-no",
                              attrs: {
                                href: _vm.$helpers.getProductDetailUrl(
                                  _vm.item.styleNameURL,
                                  _vm.item.styleNumber,
                                  color.colorNumber
                                )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$gtm.productClickEvent(
                                    _vm.item,
                                    _vm.productIndex,
                                    _vm.selectedFilters,
                                    _vm.inStock,
                                    _vm.filterByFaceWeight
                                  )
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "red-underline" }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "image-thumbnail",
                                attrs: {
                                  alt: "img",
                                  src: _vm.$helpers.getColorThumbnailImageUrl(
                                    _vm.item.styleNumber,
                                    color.colorNumber
                                  )
                                },
                                on: { error: _vm.handleImageError }
                              })
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm._m(1)
                ]
              )
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass:
          "wf-swiper-nav-button wf-swiper-nav-button-prev btn btn-full",
        attrs: { type: "button" }
      },
      [
        _c("span", {
          staticClass:
            "\n            png-icon\n            png-icon-icons-glyph--ko-chevron-left\n            png-size\n            arrow-left\n            mt-1\n          ",
          attrs: { "aria-label": "Previous color" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass:
          "wf-swiper-nav-button wf-swiper-nav-button-next btn btn-full",
        attrs: { type: "button" }
      },
      [
        _c("span", {
          staticClass:
            "\n            png-icon\n            png-icon-icons-glyph--ko-chevron-right\n            arrow-right\n            png-size\n            mt-1\n          ",
          attrs: { "aria-label": "Next color" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }